import api from "./api";
import TokenService from "./token.service";
class AuthService {
    login({ email, password }) {
        return api
            .post("/api/v1/auth/signin", {
                email: email,
                password: password
            })
            .then((response) => {
                if (response.data.accessToken) {
                    TokenService.setUser(response.data);
                }
                return response.data;
            });
    }
    forgotPassword(user) {
        return api.post('/api/v1/auth/requestResetPassword', {
                email: user.email
            })
            .then(response => {
                return response.data;
            });
    }
    confirmForgotPassword(params) {
        return  api.post( '/api/v1/auth/resetPassword', params)
            .then(response => {
                return response.data;
            });
    }
    logout() {
        TokenService.removeUser();
    }
    register(user) {
        return api.post("/api/v1/auth/signup", {
            firstName: user.firstName,
            lastName: user.lastName,
            email: user.email,
            password: user.password,
            phone: user.phone,
            companyName: user.companyName,
            companyRut: user.companyRut,
            companySize: user.companySize,
            businessSector: user.businessSector,
            terms: user.terms,
        });
    }
    registerAdmin(user) {
        return api.post("/api/v1/auth/admin/signup", {
            firstName: user.firstName,
            lastName: user.lastName,
            email: user.email,
            password: user.password,
            phone: user.phone,
            companyId: user.companyId,
            role: user.role,
        });
    }

    registerLoginUser(user) {
        return api.put("/api/v1/user/store", {
            firstName: user.firstName,
            lastName: user.lastName,
            email: user.email,
            phone: user.phone,
            role: user.role,
        });
    }

    updateUser(user) {
        return api.post("/api/v1/auth/admin/update", {
            firstName: user.firstName,
            lastName: user.lastName,
            password: user.password,
        });
    }
}
export default new AuthService();
